import {StateUtils} from "@spartacus/core";
import {MULTI_CART_DATA} from "@spartacus/cart/base/core";

export const QUOTE_EDIT_SPECIAL_REQUESTS = '[Quote-entry] Edit Quote Entry Gonvarri';

export class GonvarriQuoteEditEntry extends StateUtils.EntityProcessesIncrementAction {
  override readonly type = QUOTE_EDIT_SPECIAL_REQUESTS;
  constructor(
    public payload: {
      entryNumber: number,
      quoteCode: string,
      discount: string,
      userId: string
    }
  ) {
    super(MULTI_CART_DATA, payload.quoteCode);
  }
}
